import {PaymentDetails} from "../typings/wc-types";
import WigWagLabel from "./WigWagLabel";
import WigWagPaymentMethod from "./WigWagPaymentMethod";

const {registerPaymentMethod} = window.wc.wcBlocksRegistry;

registerPaymentMethod({
    // @ts-expect-error Props are passed at a separate time
    label: <WigWagLabel />,
    ariaLabel: 'Pay with WigWag',
    // @ts-expect-error Props are passed at a separate time
    content: <WigWagPaymentMethod />,
    // @ts-expect-error Props are passed at a separate time
    edit: <WigWagPaymentMethod />,
    name: 'wigwag',
    canMakePayment(paymentDetails: PaymentDetails) {
        const {currency_code, total_price} = paymentDetails.cartTotals;
        return currency_code === 'ZAR' && parseInt(total_price, 10) >= 500;
    },
    supports: {
        features: ['products'],
    },
    placeOrderButtonLabel: 'Pay with WigWag'
})
